// extracted by mini-css-extract-plugin
export default {"link":"LinkView-module__[local]___SI9kZ"};